import { Box, Grid2, TextField, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import toast from 'react-hot-toast';
import { sendResetPasswordEmail } from 'src/services/registeration/registerationService';

const schema = yup.object().shape({
  email: yup.string().email('Invalid email').required('Email is required'),
});


export default function ForgotPassword() {
  const { control, handleSubmit, formState: { errors, isSubmitting } } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

 const onSubmit = async (data: any) => {
  try {
    const response = await sendResetPasswordEmail(data.email);

    if (response.ok) {
      toast.success(response.message);
    } else {
      toast.error(response.message || 'Something went wrong');
    }
  } catch (error: any) {
    toast.error(error.response?.data?.message || 'Server error');
  }
};

  

  return (
    <Grid2 minHeight={600}  style={{
            backgroundImage: `linear-gradient(to top, #209cff 0%, #68e0cf 100%)`
          }} size={{xs:12, md:6}} display={'flex'} justifyContent={'center'} alignItems={'center'}>
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
      <Box width="100%" maxWidth="400px" p={4} boxShadow={2} bgcolor="white" borderRadius={2}>
        <Typography variant="h6" mb={2}>Reset your password</Typography>
        <Typography variant="body2" color="textSecondary"> Please use the email ID that was used during registration.</Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="email"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}  
                label="Email"
                fullWidth
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                margin="normal"
              />
            )}
          />
          <LoadingButton type="submit" variant="contained" fullWidth loading={isSubmitting}>
            Send Reset Link
          </LoadingButton>
        </form>
      </Box>
    </Box>
    </Grid2>
  );
}